import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import TitlePage from "../../../components/general/TitlePage/TitlePage";
import ShowcaseCard from "../../../components/Showcase/ShowcaseCard";
import ShowcaseModal from "../../../components/Showcase/ShowcaseModal";
import CategoryFilter from "../../../components/CategoryFilter/CategoryFilter";

import { showcaseFormatsUpdated } from "./showcaseData";

import "./Showcase.css";

const ShowcasePage = () => {
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [filterCategory, setFilterCategory] = useState("all");
  const [filterFormat, setFilterFormat] = useState("all");


  const categories = [
    "all",
    ...new Set(
      showcaseFormatsUpdated.map((f) => f.category).filter((c) => c)
    ),
  ];

  const formats = [
    "all",
    ...new Set(showcaseFormatsUpdated.map((f) => f.name).filter(Boolean)),
  ];

  const filteredFormats = showcaseFormatsUpdated.filter((f) => {
    const matchCategory =
      filterCategory === "all" || f.category === filterCategory;

    const matchFormat =
      filterFormat === "all" || f.name === filterFormat;

    return matchCategory && matchFormat;
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const formatParam = params.get("format");

    if (formatParam) {
      const format = showcaseFormatsUpdated.find(
        (f) =>
          f.slug === formatParam ||
          (f.demo &&
            f.demo.toLowerCase().replace(/\s+/g, "-") === formatParam)
      );

      if (format) {
        setSelectedFormat(format);
        //if (format.category) setFilterCategory(format.category);
      }
    }
  }, []);

  const handleOpenModal = (format) => {
    setSelectedFormat(format);
    // Atualiza a URL para o formato aberto
    const slugOrDemo =
      format.slug || (format.demo && format.demo.toLowerCase().replace(/\s+/g, "-"));
    window.history.pushState(null, "", `${window.location.pathname}?format=${slugOrDemo}`);
    //if (format.category) setFilterCategory(format.category);
  };

  const handleCloseModal = () => {
    setSelectedFormat(null);
    window.history.pushState(null, "", window.location.pathname);
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      console.log("URL copied!");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <main className="container">
      <Helmet>
        <title>
          {selectedFormat
            ? `${selectedFormat.name} | Showcase`
            : "Showcase"}
        </title>
      </Helmet>


      <TitlePage
        title="Showcase"
        subtitle="Explore ready-made formats and demos with previews and technical details."
      />

      <div className="showcase-filter">
        <CategoryFilter
          label="Filter by category:"
          options={categories.filter((c) => c !== "all")}
          selected={filterCategory}
          onChange={setFilterCategory}
          defaultOption={{ label: "All", value: "all" }}
        />

        <CategoryFilter
          label="Filter by format:"
          options={formats.filter((f) => f !== "all")}
          selected={filterFormat}
          onChange={setFilterFormat}
          defaultOption={{ label: "All", value: "all" }}
        />
      </div>

      <section className="showcase-features">
        {filteredFormats.map((format) => (
          <ShowcaseCard
            key={format.slug || format.demo}
            {...format}
            onOpenSpecs={() => handleOpenModal(format)}
          />
        ))}
      </section>

      {selectedFormat && (
        <ShowcaseModal
          format={selectedFormat}
          onClose={handleCloseModal}
          onCopyUrl={handleCopyUrl}
        />
      )}
    </main>
  );
};

export default ShowcasePage;
